import {
  COUNT_FOR_BOOKING, GET_ACTUALIZATION,
  GET_CHECK_IN_WEEK,
  GET_CHECK_OUT_WEEK, GET_ENDORSE_WEEK, GET_ROOMS_AVAILABLE_THIS_WEEK,
} from '../../service/constants.service';
import axios from 'axios';
import {GlobalUtility} from '../../service/global-utility.service';

const state = {
  checkInThisWeek : [],
  checkOutThisWeek : [],
  endorseThisWeek : [],
  roomsThisWeek : [],
  countForBooking: '',

  actualizationHeader :[],
  actualizationData :[],

  actualizationHotels :[],
};

const mutations = {
  set_checkIn_week :(state,params)=>{
    state.checkInThisWeek = params;
  },

  set_checkOutThisWeek : (state,params)=>{
    state.checkOutThisWeek = params;
  },

  set_endorseThis_week : (state,params) =>{
    state.endorseThisWeek = params;
  },

  set_rooms_this_week : (state,params) =>{
    state.roomsThisWeek = params;
  },

  set_count_for_booking : (state, params) =>{
    state.countForBooking = params;
  },


  set_actualization_header : (state,params) =>{
    state.actualizationHeader = params;
    state.actualizationHeader.push({floorId: '', name: 'total'});
    state.actualizationHeader.push({floorId: '', name: 'percentage'});
  },

  set_actualization_data : (state,params) =>{
    state.actualizationData = params;
  },

  set_actualization_null : (state) =>{
    state.actualizationHeader = [];
    state.actualizationData = [];
  },

  set_actualization_hotels : (state,params) =>{
    state.actualizationHotels = params;
  },

  set_actualization_hotels_null : (state,params) =>{
    state.actualizationHotels = [];
  }

};

const actions = {
async getCheckInThisWeek({commit}){
    return await axios.get(GET_CHECK_IN_WEEK).then((response)=>{
      commit('set_checkIn_week',response.data);
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'GET CHECKIN THIS WEEK');
      return false;
    })
  },

 async getCheckOutThisWeek({commit}){
    return await axios.get(GET_CHECK_OUT_WEEK).then((response)=>{
      commit('set_checkOutThisWeek',response.data);
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'GET CHECKOUT THIS WEEK');
      return false;
    });
  },

  async getEndorseThisWeek({commit}){
    return await axios.get(GET_ENDORSE_WEEK).then((response)=>{
      commit('set_endorseThis_week',response.data);
      return false;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'GET ENDORSE THIS WEEK');
      return false;
    });
  },

 async getRoomsAvailableThisWeek({commit}){
    return await axios.get(GET_ROOMS_AVAILABLE_THIS_WEEK).then((response)=>{
      commit('set_rooms_this_week',response.data);
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'GET ROOMS AVAILABLE THIS WEEK');
      return false;
    })
  },

 async getCountForBooking({commit}){
   return await axios.get(COUNT_FOR_BOOKING).then((response)=>{
     commit('set_count_for_booking',response.data);
     return true;
   }).catch((error)=>{
     GlobalUtility.failProgressBar();
     GlobalUtility.generateResponseMessage(error,'GET TOTAL FOR BOOKING');
     return false;
   })
 },

  //todo
 async  getActualUtilization({commit}, params) {
    return await  axios.post(GET_ACTUALIZATION,params).then((response) => {
      commit('set_actualization_header',response.data.floors);
      commit('set_actualization_data',response.data.data);
      commit('set_actualization_hotels',response.data.building);
      return true;
    }).catch((error) => {
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Get actualization data');
      return false;
    });
  },

  setActualizationNull({commit}){
    commit('set_actualization_null');
  },


  setActualizationHotelsNull({commit}){
    commit('set_actualization_hotels_null');
  }


};

const getters = {
  checkInThisWeek : state => state.checkInThisWeek,
  checkOutThisWeek : state => state.checkOutThisWeek,
  endorseThisWeek : state => state.endorseThisWeek,
  roomsThisWeek :state => state.roomsThisWeek,
  countForBooking: state => state.countForBooking,
  actualizationHeader: state => state.actualizationHeader,
  actualizationData: state => state.actualizationData,
  actualizationHotels: state => state.actualizationHotels,
}

export default {state,actions,mutations,getters};

